module.exports = __webpack_public_path__ + "img/微信图片_20200810010808.4568ed88.jpg";